import { REQUEST_TARGET_MODULES } from "../../../../Library/APIsTarget";

const TextHandler = [
  { id: 1, name: "Please fill up the form with correctly" },
  { id: 2, name: "This course has already been added to the 'MY PCF'" },
  { id: 3, name: "You cannot enroll in this course because it has not been taken previously" },
  { id: 4, name: "You cannot enroll in this course because your grade is A" },
  { id: 5, name: "You cannot enroll in this course because the final grade is not yet available." },
]
const handlePaste = (e) => {
  e.preventDefault();
  return false;
};

const isValidEmail = (val) => {
  let message = "",
    match = false;
  let regEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!regEmail.test(val)) {
    match = false;
    message = "Invalid Email Address";
  } else {
    match = true;
    message = "";
  }

  return { mail: val, message: message, match: match };
};

const isValidEmailParent = (val) => {
  let message = "",
    match = false;
  let regEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  if (!regEmail.test(val)) {
    match = false;
    message = "Invalid Email Address";
  } else if (val.toLowerCase().includes("@student") || val.toLowerCase().endsWith("sgu.ac.id")) {
    match = false;
    message = "SGU email addresses are not allowed for parent email";
  } else {
    match = true;
    message = "";
  }

  return { mail: val, message: message, match: match };
};

const handlerRepeatMatch = (original, value) => {
  var message = "";
  if (value) {
    if (value === original) {
      message = "match";
    } else {
      message = "not match";
    }
  }

  return { original: original, value: value, match: message };
};

const GET_COURSE_VALIDATE_REQ = async (params) => {
  const param = {
    parameters: params,
    target_data: "GET_COURSE_VALIDATE_REQ",
  };
  const results = await REQUEST_TARGET_MODULES(param);
  return results;
}

const ConvertEventItem = (data) => {
  let events = [];
  if (data) {
    let hasConflict = ConflictSchedule(data);
    hasConflict.map((v) => {
      var objItem = {};
      objItem.title = v.label ? v.label : (v.section_id ? (v.course ? v.course.coursetitle : "-") : v.label);
      objItem.id = v.section_id ? v.section_id : "";
      objItem.start = v.start_dt;
      objItem.end = v.end_dt;
      objItem.groupId = JSON.stringify(v);
      objItem.event_room = (v.event_room) ? v.event_room : "";
      events.push(objItem);
    })
  }

  return events;
}

const ConflictSchedule = (dataArr) => {
  const updatedEvents = [...dataArr];

  for (let i = 0; i < updatedEvents.length; i++) {
    for (let j = i + 1; j < updatedEvents.length; j++) {
      const eventA = updatedEvents[i];
      const eventB = updatedEvents[j];

      const startA = new Date(eventA.start_dt);
      const endA = new Date(eventA.end_dt);
      const startB = new Date(eventB.start_dt);
      const endB = new Date(eventB.end_dt);

      if (startA < endB && endA > startB) {
        eventA.conflict = true;
        eventB.conflict = true;
      }
    }
  }

  return updatedEvents;
}


export { TextHandler, handlePaste, isValidEmail, handlerRepeatMatch, GET_COURSE_VALIDATE_REQ, ConvertEventItem, isValidEmailParent }